import Axios from "axios";

const URL_AUTH = import.meta.env.VITE_AUTH_URL;

export function ConfirmMovilService(formValue, token) {
  return new Promise(async (resolve, reject) => {
    try {
      console.log(formValue)
      const response = await Axios.post(
        `${URL_AUTH}/api/brain/v1/admin/signup/step/2`,
        formValue,
        {
          headers: {
            "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
            Authorization: `Bearer ${token}`,
          }
        }
      );
      console.log("Verification movil response: ", response);
      resolve(response);
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
}